import { Phone, MessageCircle, Instagram } from "lucide-react";
import { ARVI, waLink, DEFAULT_WA_MESSAGE } from "../../lib/arvi";

export default function MobileStickyBar() {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-maroon-deep border-t border-[hsl(var(--gold)/0.4)] grid grid-cols-3"
    >
      <a
        href={`tel:+${ARVI.whatsapp}`}
        data-testid="mobile-call-cta"
        className="flex flex-col items-center justify-center py-3 text-ivory/85 active:bg-maroon transition-colors"
      >
        <Phone className="h-4 w-4 text-gold" />
        <span className="text-[10px] tracking-[0.2em] uppercase mt-1">Call</span>
      </a>
      <a
        href={waLink(DEFAULT_WA_MESSAGE)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bar-whatsapp-cta"
        className="flex flex-col items-center justify-center py-3 bg-gold text-maroon active:opacity-80"
      >
        <MessageCircle className="h-4 w-4" />
        <span className="text-[10px] tracking-[0.2em] uppercase mt-1 font-medium">
          WhatsApp
        </span>
      </a>
      <a
        href={ARVI.instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-instagram-cta"
        className="flex flex-col items-center justify-center py-3 text-ivory/85 active:bg-maroon transition-colors"
      >
        <Instagram className="h-4 w-4 text-gold" />
        <span className="text-[10px] tracking-[0.2em] uppercase mt-1">Instagram</span>
      </a>
    </div>
  );
}
